import { render, staticRenderFns } from "./MoneyPlacementDetails.vue?vue&type=template&id=8b6d10ba&"
import script from "./MoneyPlacementDetails.vue?vue&type=script&lang=js&"
export * from "./MoneyPlacementDetails.vue?vue&type=script&lang=js&"
import style0 from "./MoneyPlacementDetails.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports